import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Modal, ModalHeader, ModalBody, Button, ModalFooter, FormGroup, Input, Label } from "reactstrap";

function CloneCertificateOptions(props) {
  const { isOpen, toggle, onOptionsSelected } = props;
  const [includeRegulations, setIncludeRegulations] = useState(true);
  const [includeValidity, setIncludeValidity] = useState(true);
  const [includePDFS, setIncludePDFS] = useState(true);

  function handleSelection(e, choice) {
    onOptionsSelected({
      includeRegulations,
      includeValidity,
      includePDFS,
    });
  }

  return (
    <Modal isOpen={isOpen} size={"sm"} className={""} backdrop={"static"}>
      <ModalHeader>
        <FormattedMessage id="certificates.clone_certificate.options" defaultMessage="Clone certificate options" />
      </ModalHeader>
      <ModalBody>
        <FormGroup check>
          <Input id="includeRegulations" type="checkbox" checked={includeRegulations} onChange={(e) => setIncludeRegulations(e.target.checked)} />{" "}
          <Label check for="includeRegulations">
            <FormattedMessage id="certificates.clone_certificate.options.regulations" defaultMessage="Include regulations" />
          </Label>
        </FormGroup>
        <FormGroup check>
          <Input id="includeValidity" type="checkbox" checked={includeValidity} onChange={(e) => setIncludeValidity(e.target.checked)} />{" "}
          <Label check for="includeValidity">
            <FormattedMessage id="certificates.clone_certificate.options.validity" defaultMessage="Include validity dates" />
          </Label>
        </FormGroup>
        <FormGroup check>
          <Input id="includePDF" type="checkbox" checked={includePDFS} onChange={(e) => setIncludePDFS(e.target.checked)} />{" "}
          <Label check for="includePDF">
            <FormattedMessage id="certificates.clone_certificate.options.pdfs" defaultMessage="Include pdfs" />
          </Label>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="dark" outline={true} onClick={toggle}>
          <FormattedMessage id="app.cancel" defaultMessage="Cancel" />
        </Button>
        <Button
          color="primary"
          outline={true}
          onClick={(e) => {
            e.preventDefault();
            handleSelection();
          }}
        >
          <FormattedMessage id="certificates.clone_certificate.clone" defaultMessage="Clone" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default CloneCertificateOptions;
